module.exports = __webpack_public_path__ + "img/papo-clever.f60d3218.png";